// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { squareCheck16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-square-check': IconSquareCheck;
    }
}

/**
 * The icon component for the 'squareCheck' icon
 */
export class IconSquareCheck extends IconSvg {
    public constructor() {
        super(squareCheck16X16);
    }
}

registerIconSvg('icon-square-check', IconSquareCheck);
export const iconSquareCheckTag = 'nimble-icon-square-check';
